import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import BreadcrumbsSub from '../../components/BreadcrumbsSub';

const mapStateToProps = null;

const mapDispatchToProps = {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BreadcrumbsSub));
